module.exports = __webpack_public_path__ + "media/images/icons/laptop-8e3c1334ea2fb4dfd83b6629446d6112.svg";